/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ExperimentMetadata } from "./ExperimentMetadata";
import {
  ExperimentMetadataFromJSON,
  ExperimentMetadataFromJSONTyped,
  ExperimentMetadataToJSON,
  ExperimentMetadataToJSONTyped,
} from "./ExperimentMetadata";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { Experiment } from "./Experiment";
import {
  ExperimentFromJSON,
  ExperimentFromJSONTyped,
  ExperimentToJSON,
  ExperimentToJSONTyped,
} from "./Experiment";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface ExperimentDetail
 */
export interface ExperimentDetail {
  /**
   *
   * @type {Experiment}
   * @memberof ExperimentDetail
   */
  experiment: Experiment;
  /**
   *
   * @type {Company}
   * @memberof ExperimentDetail
   */
  company?: Company | null;
  /**
   *
   * @type {ProcessingState}
   * @memberof ExperimentDetail
   */
  state: ProcessingState;
  /**
   *
   * @type {ExperimentMetadata}
   * @memberof ExperimentDetail
   */
  parsedMetadata?: ExperimentMetadata | null;
}

/**
 * Check if a given object implements the ExperimentDetail interface.
 */
export function instanceOfExperimentDetail(
  value: object,
): value is ExperimentDetail {
  if (!("experiment" in value) || value["experiment"] === undefined)
    return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function ExperimentDetailFromJSON(json: any): ExperimentDetail {
  return ExperimentDetailFromJSONTyped(json, false);
}

export function ExperimentDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentDetail {
  if (json == null) {
    return json;
  }
  return {
    experiment: ExperimentFromJSON(json["experiment"]),
    company:
      json["company"] == null ? undefined : CompanyFromJSON(json["company"]),
    state: ProcessingStateFromJSON(json["state"]),
    parsedMetadata:
      json["parsedMetadata"] == null
        ? undefined
        : ExperimentMetadataFromJSON(json["parsedMetadata"]),
  };
}

export function ExperimentDetailToJSON(json: any): ExperimentDetail {
  return ExperimentDetailToJSONTyped(json, false);
}

export function ExperimentDetailToJSONTyped(
  value?: ExperimentDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiment: ExperimentToJSON(value["experiment"]),
    company: CompanyToJSON(value["company"]),
    state: ProcessingStateToJSON(value["state"]),
    parsedMetadata: ExperimentMetadataToJSON(value["parsedMetadata"]),
  };
}
